import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { vehicleTransactionFormDefault } from "@factory/form/form.default";
import { VehicleTransactionFormRule, VehicleTransactionFormSchema } from "@factory/form/form.rule";
import { useQyCreateVehicleTransaction } from "@factory/query/vehicle-transaction.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewVehicleTransaction() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateVehicleTransaction } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New VehicleTransaction is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addVehicleTransaction, isLoading: isCreating } =
    useQyCreateVehicleTransaction(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<VehicleTransactionFormSchema>({
    defaultValues: vehicleTransactionFormDefault,
    resolver: zodResolver(VehicleTransactionFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: VehicleTransactionFormSchema) => {
    const formData = mapCreateVehicleTransaction(form);
    addVehicleTransaction(formData);
  };
  const handleValidateError = (err: FieldErrors<VehicleTransactionFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
